import { IRecipeProduct, LogicalOperatorsBetweenProducts, Product } from 'hooks/useCannectAssistant/types'
import { Template } from './hooks/useTemplate'

export const fromTemplateToPrescription = (template: Template, prescriptionProducts: Product[]) => {
  const newPrecriptionProducts: Product[] = []
  const newLogicalOperators: LogicalOperatorsBetweenProducts[] = []

  template.products.forEach((product) => {
    if (prescriptionProducts.find((p) => p.id === product.product.id)) return

    const isCombo = (product.product as any).is_combo

    if (isCombo && product.alternatives.length > 0) {
      // Combo: adicionar pai + filhos com combo_origin_id
      newPrecriptionProducts.push({
        ...product.product,
        includedInPrescription: true,
        bottlesPerYear: product.required_bottles,
        howToUse: '',
        is_combo: true
      })
      newLogicalOperators.push('and')

      product.alternatives.forEach((child) => {
        newPrecriptionProducts.push({
          ...child.product,
          includedInPrescription: true,
          bottlesPerYear: child.required_bottles,
          howToUse: child.prescription,
          combo_origin_id: product.product.id
        })
        newLogicalOperators.push('and')
      })
    } else {
      newPrecriptionProducts.push({
        ...product.product,
        includedInPrescription: true,
        bottlesPerYear: product.required_bottles,
        howToUse: product.prescription
      })

      if (product.alternatives.length > 0) {
        newLogicalOperators.push('or')
      } else {
        newLogicalOperators.push('and')
      }

      product.alternatives.forEach((alternative, alternativeIndex) => {
        newPrecriptionProducts.push({
          ...alternative.product,
          includedInPrescription: true,
          bottlesPerYear: alternative.required_bottles,
          howToUse: alternative.prescription
        })
        if (alternativeIndex === product.alternatives.length - 1) {
          newLogicalOperators.push('and')
        } else {
          newLogicalOperators.push('or')
        }
      })
    }
  })

  if (newLogicalOperators.length === newPrecriptionProducts.length) {
    newLogicalOperators.pop()
  }

  return {
    products: newPrecriptionProducts,
    logicalOperatorsBetweenProducts: newLogicalOperators
  }
}

export const fromPrescriptionToApiProducts = (
  products: Product[],
  logicalOperators: LogicalOperatorsBetweenProducts[]
): IRecipeProduct[] => {
  const newRecipeRequestProducts: IRecipeProduct[] = []
  const mainProducts = products.filter((p) => !p.combo_origin_id)

  let newRecipeRequestProduct: IRecipeProduct = {
    product_id: 0,
    prescription: '',
    required_bottles: 0,
    alternatives: []
  }

  mainProducts.forEach((product, index) => {
    const recipeProduct: IRecipeProduct = {
      product_id: product.id,
      prescription: product.howToUse ?? '',
      required_bottles: Number(product.bottlesPerYear) || Number(product.quantity) || 0,
      alternatives: [],
      parent_product_id: null
    }

    if (product.is_combo) {
      // Combo: adicionar o combo + filhos com parent_product_id
      newRecipeRequestProducts.push(recipeProduct)
      const comboChildren = products.filter((p) => p.combo_origin_id === product.id)
      comboChildren.forEach((child) => {
        newRecipeRequestProducts.push({
          product_id: child.id,
          prescription: child.howToUse ?? '',
          required_bottles: Number(child.bottlesPerYear) || Number(child.quantity) || 0,
          alternatives: [],
          parent_product_id: product.id
        })
      })
      return
    }

    if (index === 0) {
      newRecipeRequestProduct = recipeProduct
      return
    }

    if (logicalOperators[index - 1] === 'or') {
      newRecipeRequestProduct = {
        ...newRecipeRequestProduct,
        alternatives: [
          ...newRecipeRequestProduct.alternatives,
          {
            product_id: product.id,
            prescription: product.howToUse ?? '',
            required_bottles: Number(product.bottlesPerYear) || Number(product.quantity) || 0
          }
        ]
      }
    } else {
      newRecipeRequestProducts.push(newRecipeRequestProduct)
      newRecipeRequestProduct = recipeProduct
    }
  })

  if (newRecipeRequestProduct.product_id !== 0) {
    newRecipeRequestProducts.push(newRecipeRequestProduct)
  }

  return newRecipeRequestProducts
}
